/**
 * Escape HTML para inserção segura em innerHTML.
 * NÃO usar <template>: em Chrome, template.textContent + template.innerHTML
 * retorna string vazia (conteúdo fica só no DocumentFragment).
 * @param {*} s
 * @returns {string}
 */
export function escapeHtml(s) {
	if (s == null) return '';
	const d = document.createElement('div');
	d.textContent = String(s);
	return d.innerHTML;
}

export default escapeHtml;
